import React, { useState } from 'react';
import { Event } from '../../../../../model/event';
import { Card } from '../../../../../components/Card/Card';
import { PrintSectionTicketOverlay } from './print_section_ticket_overlay';
import { VenueSection } from '../../../../../model/venue';
import { ContingentList } from '../../../../../components/Seatmap/ContingentList';
import { Button } from '../../../../../components/Button/Button';
import { Modal } from '../../../../../components/Modal/Modal';
import { Split } from '../../../../../components/Split/Split';
import { t } from '../../../../../locales/translate';
import { Stack } from '../../../../../components/Stack/Stack';
import { Spacer } from '../../../../../components/Spacer/Spacer';

interface Props {
  event: Event;
  section: VenueSection;
  onTicketsCreated: (info: { generalSectionIds: Array<string> }) => Promise<void>;
}

export function PrintGeneralAdmission({ event, section, onTicketsCreated }: Props): JSX.Element {
  const [createTickets, setCreateTickets] = useState(false);

  if (!event.venuePlan) return <></>;

  return (
    <Card title={t.model.ticket.overview}>
      <Spacer size="xs" />
      <Split ratio={0.8}>
        <ContingentList event={event} section={section} linkToContingent />
        <Stack>
          <h3>{t.model.ticket.issueTickets}</h3>
          <p>{t.model.contingent.hereYouCanGenerateFreeTickets}</p>
          <Button type="primary" title={t.model.ticket.issueTickets} onClick={() => setCreateTickets(true)} />
        </Stack>
      </Split>
      <Modal open={createTickets} position="aside" size="small" title={t.model.contingent.generateFreeTickets}>
        <PrintSectionTicketOverlay
          event={event}
          section={{
            id: section.id,
            pricingCategory: section.pricingCategoryId ? { id: section.pricingCategoryId } : null,
          }}
          onClose={() => setCreateTickets(false)}
          onTicketsCreated={({ sectionId }) => onTicketsCreated({ generalSectionIds: [sectionId] })}
        />
      </Modal>
    </Card>
  );
}
